import React from "react";

/**
 * Bandeau “Ils m’ont fait confiance” — version Marquee CSS (sans react-slick).
 * - Pas d’imports slick
 * - On triple le ruban pour un défilement continu
 * - Le style est géré par les classes .clients-wrap / .clients-viewport / .clients-track / .clients-item
 */
const logos = [
  { src: "/images/logos/gaultetmillauluxembourg.jpg", alt: "Gault&Millau Luxembourg" },
  { src: "/images/logos/archibalddeprince.jpg",       alt: "Archibald De Prince" },
  { src: "/images/logos/artsetgastronomie.jpg",       alt: "Arts&Gastronomie" },
  { src: "/images/logos/sodexo.jpg",                  alt: "Sodexo Luxembourg" },
  { src: "/images/logos/aubonpain.jpg",               alt: "Au Bon Pain" },
  { src: "/images/logos/casino2000.jpg",              alt: "Casino 2000" },
  { src: "/images/logos/chezdoudou.jpg",              alt: "Chez Doudou" },
  { src: "/images/logos/grunewaldchefstable.jpg",     alt: "Grünewald Chef's Table" },
  { src: "/images/logos/lacapu.jpg",                  alt: "Le Capu" },
  { src: "/images/logos/universitedelorraine.jpg",    alt: "Université de Lorraine" },
  { src: "/images/logos/lacourdessens.jpg",           alt: "La Cour des Sens" },
  { src: "/images/logos/laplacedarmes.jpg",           alt: "La Place d'Armes" },
  { src: "/images/logos/recouvreur.jpg",              alt: "Recouvreur" },
  { src: "/images/logos/largousier.jpg",              alt: "L'Argousier" },
  { src: "/images/logos/latabledubelvedere.jpg",      alt: "La Table du Belvédère" },
  { src: "/images/logos/polmard.jpg",                 alt: "Boucherie Polmard" },
  { src: "/images/logos/latelierwindsor.jpg",         alt: "Atelier Windsor" },
  { src: "/images/logos/yumity.jpg",                  alt: "Yumity" },
  { src: "/images/logos/latoya.jpg",                  alt: "La Toya" },
  { src: "/images/logos/lemoulindelapierie.jpg",      alt: "Le Moulin de la Piérie" },
  { src: "/images/logos/lhetrebeimmuseum.jpg",        alt: "L'Hêtre Beim Musée" },
  { src: "/images/logos/maisondessoeursmacarons.jpg", alt: "La Maison des Soeurs Macarons" },
  { src: "/images/logos/marcotullio.jpg",             alt: "Traiteur Marcotullio" },
  { src: "/images/logos/millessence.jpg",             alt: "Restaurant Millessence" },
  { src: "/images/logos/quaidessaveurs.jpg",          alt: "Le Quai des Saveurs" },
  { src: "/images/logos/museumaquariumdenancy.jpg",   alt: "Museum Aquarium de Nancy" },
  { src: "/images/logos/nigloland.jpg",               alt: "Nigloland" },
  { src: "/images/logos/pieceduboucher.jpg",          alt: "Pièce du Boucher" },
];

// On répète 3x pour que l’animation soit toujours pleine (et super fluide)
const strip = [...logos, ...logos, ...logos];

export default function TrustedClients() {
  return (
    <section className="clients-wrap" aria-labelledby="trusted-title">
      <h2 id="trusted-title" className="trusted-title">
        Ils me font confiance. Pourquoi pas vous ?
      </h2>

      <div className="clients-viewport" aria-hidden>
        <div className="clients-track">
          {strip.map((logo, i) => (
            <div className="clients-item" key={`${logo.src}-${i}`}>
              <img
                src={logo.src}
                alt={logo.alt}
                loading="lazy"
                width="120"
                height="120"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}